import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Data, AppService } from '../../app.service';
import { Product } from '../../app.models';


// ********************************************** CONTROLS COMPONENT CLASS ********************************************
@Component({
  selector: 'app-controls',
  templateUrl: './controls.component.html',
  styleUrls: ['./controls.component.scss']
})
export class ControlsComponent implements OnInit {
  @Input() product: Product;
  @Input() type: string;
  //@Output() onOpenDownloadAppPage: EventEmitter<any> = new EventEmitter();
  @Output() onAddToCart: EventEmitter<any> = new EventEmitter();
  @Output() onOpenProductDialog: EventEmitter<any> = new EventEmitter();
  @Output() onUpdateCartComponent: EventEmitter<any> = new EventEmitter<any>();
  public count:number = 1;
  public align = 'center center';
  constructor(public appService:AppService, public snackBar: MatSnackBar) { }


  // -- FUNC Ng On Init
  ngOnInit() {
    
  }


  // -- FUNC Ng On Changes
  ngOnChanges(): void {

    this.setProperProductCartCountLabel();
  }


  // -- FUNC Layout Align
  public layoutAlign(){
    if(this.type == 'all'){
      this.align = 'space-between center';
    }
    else if(this.type == 'wish'){
      this.align = 'start center';
    }
    else{
      this.align = 'center center';
    }
  }


  // -- FUNC Set Proper Product Cart Count Label
  private setProperProductCartCountLabel() {
    // Try to find product in the cart products list
    let cartProduct = this.appService.Data.cartList.filter(item => item.productID == this.product.productID)[0];

    // check if we didnt find product in cart and if we didnt then set count to 0 
    if (!cartProduct) {
      this.count = 0;
    }
    // else if we did find it then set count to cartcount of the product
    else {
      this.count = cartProduct.cartCount;
    }
  }


  // -- FUNC Increment Product Cart Count
  public incrementProductCartCount() {

    // Try to find current product in the cart products list
    let cartProduct = this.appService.Data.cartList.filter(item => item.productID == this.product.productID)[0];

    // check if we didnt find product in cart and if we didnt then add this product to cart products list
    if (!cartProduct) {

      this.product.cartCount = 1;
      this.appService.Data.cartList.push(this.product);
      this.count = 1;

      // recalculate cart
      this.recalculateTotalCartCountAndPrice();
    }
    else {
      if (cartProduct.cartCount < this.product.productQuantity) {
        // Find index of found cart product
        let cartProductIndex = this.appService.Data.cartList.findIndex(item => item.productID == this.product.productID);

        this.appService.Data.cartList[cartProductIndex].cartCount = this.appService.Data.cartList[cartProductIndex].cartCount + 1;
        this.count = this.appService.Data.cartList[cartProductIndex].cartCount;

        // recalculate cart
        this.recalculateTotalCartCountAndPrice();
      }
      else {
        this.snackBar.open('К сожалению доступное количество единиц этого товара на данный момент равняется: ' + this.product.productQuantity + ' шт.', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
        return false;
      }

    }
  }


  // -- FUNC Decrement Product Cart Count
  public decrementProductCartCount() {

    // Try to find product to remove in the cart products list
    let cartProduct = this.appService.Data.cartList.filter(item => item.productID == this.product.productID)[0];

    // check if we didnt find product in cart and if we didnt then add this product to cart products list
    if (!cartProduct) {
      this.snackBar.open('Товар не найден в корзине', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
    }
    else {

      let cartProductIndex = this.appService.Data.cartList.findIndex(item => item.productID == this.product.productID);

      this.appService.Data.cartList[cartProductIndex].cartCount = this.appService.Data.cartList[cartProductIndex].cartCount - 1;
      this.count = this.appService.Data.cartList[cartProductIndex].cartCount;

      // recalculate cart
      this.recalculateTotalCartCountAndPrice();

      // Check if the product to remove cart count is less or equal to 0 and if yes then remove this product from car list 
      if (this.appService.Data.cartList[cartProductIndex].cartCount <= 0) {
        // Find index of found cart product
        this.appService.Data.cartList.splice(cartProductIndex, 1);
        this.count = 0;

        // recalculate cart
        this.recalculateTotalCartCountAndPrice();

      }

    }
  }


  // -- FUNC Recalculate Total Cart Count And Price
  private recalculateTotalCartCountAndPrice() {
    // recalculate total cart count and price
    this.appService.Data.totalCartCount = 0;
    this.appService.Data.totalCartPrice = 0;
    var totalCartCount = 0;
    var totalCartPrice = 0;
    for (var i = 0; i < this.appService.Data.cartList.length; i++) {
      totalCartCount += this.appService.Data.cartList[i].cartCount;

      // check if product is discount and calculate total cart cost by multiplying each product with its quantity
      if (this.appService.Data.cartList[i].isDiscount) {
        totalCartPrice += (((100 - this.appService.Data.cartList[i].discountPerc) / 100) * this.appService.Data.cartList[i].price) * this.appService.Data.cartList[i].cartCount;
      }
      else {
        totalCartPrice += this.appService.Data.cartList[i].price * this.appService.Data.cartList[i].cartCount;
      }
    }
    this.appService.Data.totalCartCount = totalCartCount;
    this.appService.Data.totalCartPrice = totalCartPrice;

 
    this.updateCartComponent();
  }


  // -- FUNC Open Product Dialog
  public openProductDialog(event){
    this.onOpenProductDialog.emit(event);
  }


  /*// -- FUNC Open Download App Page
  public openDownloadAppPage(event) {
    this.onOpenDownloadAppPage.emit(event);
  }*/


  // -- FUNC Add To Cart
  public addToCart(event) {
    this.onAddToCart.emit(event);
    this.setProperProductCartCountLabel();
  }


  // -- FUNC Update Cart Component
  public updateCartComponent() {
    if (this.onUpdateCartComponent) {
      this.onUpdateCartComponent.emit(event);
    }
  }

}
